import { protectedAxiosInstance } from "@/services/axios/axios";

type Pose = "left" | "straight" | "right";
type CaptureUploads = Record<Pose, { key: string; url: string }>;

function dataUrlToBlob(dataUrl: string) {
  const [header, data] = dataUrl.split(",");
  const mime = header.match(/:(.*?);/)?.[1] || "image/jpeg";
  const bytes = atob(data);
  return new Blob([Uint8Array.from(bytes, (byte) => byte.charCodeAt(0))], {
    type: mime,
  });
}

export async function saveProfileLandmarks([left, straight, right]: [
  string,
  string,
  string,
]) {
  const uploadResponse = await protectedAxiosInstance.post(
    "/users/profile-landmarks/upload-urls"
  );
  const captures = uploadResponse?.data?.data?.captures as CaptureUploads;
  if (!captures?.left || !captures?.straight || !captures?.right) {
    throw new Error("Could not prepare face capture upload");
  }

  await Promise.all(
    (Object.entries({ left, straight, right }) as [Pose, string][]).map(
      async ([pose, image]) => {
        const response = await fetch(captures[pose].url, {
          method: "PUT",
          headers: { "Content-Type": "image/jpeg" },
          body: dataUrlToBlob(image),
        });
        if (!response.ok) throw new Error("Could not upload face capture");
      }
    )
  );

  await protectedAxiosInstance.post("/users/profile-landmarks", {
    captures: Object.fromEntries(
      (Object.entries(captures) as [Pose, CaptureUploads[Pose]][]).map(
        ([pose, upload]) => [pose, upload.key]
      )
    ),
  });
}
